import React, { Component } from 'react';
import Analytics from 'react-ga';
import SimplePageTemplate from '../SimplePageTemplate';
import image1 from './assets/road-show-1.png';
import image2 from './assets/road-show-2.png';
import image3 from './assets/road-show-3.png';
import bannerImage from './assets/road-show-banner.png';
import './styles.css';

export default class RoadShowPage extends Component {

  componentDidMount() {

    Analytics.pageview('/roadshow');
  }

  render(){
    return (
      <SimplePageTemplate location={this.props.location}
                          bannerImage={bannerImage}
                          bannerAlt="Save up to 40% off Pearl drum sets"
                          image1={image1}
                          image2={image2}
                          image3={image3}
                          imageAlt="Pearl Road Show drums">
        <p>
          Pearl sets the bar for value in its new Road Show drums! These durable,
          complete sets start at just $499 and include everything you need to start
          your rhythmic journey to the big time. The right gear is essential, so
          trust Pearl to deliver the quality you need to keep playing year after year.
          What you get:
        </p>
        <div className="road-show-list">
          <ul>
            <li>Your Choice of 4 Finishes</li>
            <li>Double Braced Hardware</li>
            <li>Durable, 9-ply Drum Shells</li>
            <li>16" Crash-Ride Cymbal</li>
          </ul>
          <ul>
            <li>14" Hybrid Hi-Hats</li>
            <li>Maple Drum Sticks (2 pairs)</li>
            <li>Professional Stick Bag</li>
            <li>Limited 2 Year Warranty</li>
            <li>Pearl Drum Poster</li>
          </ul>
        </div>
      </SimplePageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RoadShowPage/index.js